import { watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import store from '@/store';
import { loadUserData } from '../userService';

async function waitForAuth0(isLoading) {
  if (!isLoading.value) return;
  await new Promise(resolve => {
    const stop = watch(isLoading, done => {
      if (!done) { stop(); resolve(); }
    });
  });
}

export async function authGuard(to, _from, next) {
  if (to.meta.public) return next();

  const { user, isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  await waitForAuth0(isLoading);

  if (!isAuthenticated.value) return next({ name: 'HomeView' });
  if (!user.value?.sub)       return next('/error');

  try {
    store.commit('SET_SHOW_LOADING_MODAL', true);
    const userData = await loadUserData(user.value, getAccessTokenSilently);

    const permissions = store.state.authentication.permissions || [];
    const isAdmin = permissions.includes('admin_only') && userData.is_admin;

    // Admins bypass everything — let them through immediately
    if (isAdmin) return next();

    // Attach resolved data so subsequent guards don't re-fetch
    to.meta._userData = userData;

    return next();
  } catch {
    store.commit('SET_ERROR_MODAL_MESSAGE', 'Navigation error.');
    return next('/error');
  } finally {
    store.commit('SET_SHOW_LOADING_MODAL', false);
  }
}
